import React from 'react';
import Navigation from "./Navigation";

import '../global.css'
import './withHeadSideFoot.css'


/** This is the template that wraps all of our pages.   There is not too much here, anymore, but we still have
 * the navigation bar on top, some empty margins (used to have stuff in them), and a footer.
 *
 * @param WrappedComponent  The component to stick inside the template, e.g. home, games index, etc.
 */
const withHeadSideFoot = (WrappedComponent, params) => (props) => {

   let widerContent = null;
   if (!!params) {
      widerContent = params.widerContent;
   }

   const columnClass = widerContent
      ? "col-lg-1 col-md-1 hidden-sm hidden-xs container-fluid no-top-margin"
      : "col-lg-2 col-md-2 col-sm-1 hidden-xs container-fluid no-top-margin"  ;
   const mainContentColummn = widerContent
      ? "col-lg-10 col-md-10 container-fluid app-div no-top-margin"
      : "col-lg-8 col-md-8 col-sm-10 container-fluid app-div no-top-margin" ;

   // bg
   return (
      <div className="">
         <Navigation/>

         <div className="row container-fluid header-image"> </div>

         <div className="row container-fluid app-div no-top-margin">
            <div className={columnClass}>
            </div>
            <div className={mainContentColummn}>
               <WrappedComponent {...props}/>
            </div>
            <div className={columnClass}>
            </div>
         </div>
         <footer className="row container-fluid text-center">
            <div>
               <a href={'https://www.ourtreasurehunt.com/feedback'}>Provide feedback</a> *
               <a href={'https://www.ourtreasurehunt.com/bugs'}>Report problem</a> *
               <a href={'https://www.ourtreasurehunt.com/tipjar'}>Donate</a>
            </div>
            <div className="footer-div">
               <a href={'https://www.ourtreasurehunt.com/terms-of-service'}>terms of service</a>
               <a href={'https://www.ourtreasurehunt.com/privacy'}>privacy</a>
               <a href={'https://www.ourtreasurehunt.com/the-great-outdoors'}>the great outdoors</a>
            </div>
            <p><small> &#169; 2020 The Great Outdoors, LLC, d/b/a Our Treasure Hunt</small></p>
         </footer>
      </div>
   )
};

export default withHeadSideFoot;



// WEBPACK FOOTER //
// ./src/components/withHeadSideFoot.js